import { Component } from 'react';
import HandlerChange from '../utils/handlerChange';
import HandlerValidation from '../utils/handlerValidation';
import * as utils from '../utils/util';
import { getVision } from '../../src/services/auth';
import { VISIONS } from '../utils/constants';

export default class BaseComponent extends Component {
    constructor(props, state) {
        super(props);
        this.state = { validations: [], ...state };

        this.showMessageToast = utils.showMessageToast;
        this.showMessageToastCustom = utils.showMessageToastCustom;
    }

    translate = (field, fileTranslation, params) => {
        const { t } = this.props;
        if (field && field.toString().includes("line-picking") && field.toString().includes("CIM")
            && (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD)) {
            field = field.replace('CIM', 'CIMFiasa');
        }
        if (fileTranslation) {
            if (params) {
                return t(`${fileTranslation}:${field}`, params);
            } else {
                return t(`${fileTranslation}:${field}`);
            }
        } else if (params) {
            return (t(field, params));
        } else {
            return (t(field));
        }
    }

    changeLanguage = (lng) => {
        const { i18n } = this.props;
        i18n.changeLanguage(lng);
        window.location.reload();
    };

    // It have the function of let the model valid or invalid
    onModelChange = (propName, model) => {
        model.isValid = this.isValid();
        this.setState({ [propName]: model });
    };

    onValueChange = (e, value, stateModel, numericOptions) => {
        if (stateModel === undefined || stateModel === null) {
            stateModel = this.state;
        }

        HandlerChange.onValueChange(e, value, stateModel, numericOptions, (propName, model) => {
            HandlerValidation.onValidation(e, value, this.state.validations);
            if (this.props.onValidation) {
                const modelName = this.props.name.split('.')[0];
                this.props.onValidation(this.isValid(), this.state.validationField, '', '', modelName);
                this.forceUpdate();
            }

            if (model && propName in stateModel) {
                this.setState({ [propName]: model });
                this.onModelChange(propName, model);
            }

            if (this.props.onChange) {
                this.props.onChange(this.props.name ? this.props.name : propName, model);
            }
        });
    };

    onRowChange = (e, value, stateModel, numericMaskParameters, callback) => {
        if (stateModel === undefined || stateModel === null) {
            stateModel = this.state;
        }

        HandlerChange.onRowChange(e, value, stateModel, numericMaskParameters, callback);
        HandlerValidation.onValidation(e, value, this.state.validations);

        if (this.props.onValidation) {
            const modelName = this.props.name.split('.')[0];
            this.props.onValidation(this.isValid(), this.state.validationField, '', '', modelName);
            this.forceUpdate();
        } else if (stateModel.onValidation) {
            const modelName = stateModel.name.split('.')[0];
            stateModel.onValidation(this.isValid(), this.state.validationField, '', '', modelName);
            this.forceUpdate();
        }

        if (this.props.onChange) {
            this.props.onChange(this.props.name, stateModel);
        }
    };

    onValidation = (isValid, field, group, message, propNameState) => {
        const stateValidations = this.state.validations;
        stateValidations.find((vl) => vl.field === field).isValid = isValid;
        stateValidations.find((vl) => vl.field === field).message = message;
        this.setState({ validations: stateValidations });

        const modelName = propNameState.split('.')[0];
        this.onModelChange(propNameState, this.state[modelName]);
    }

    onChange = (propName, model) => {
        const propsArr = propName.split('.');
        HandlerChange.setValue(this.state[propsArr[0]], propsArr, model);
    };

    onValidationElement = (e) => {
        const modelName = e.target.name.split('.')[0];
        HandlerValidation.onValidation(e, e.target.value, this.state.validations); this.setState({});
        this.onModelChange(modelName, this.state[modelName]);
    };

    // All Validation
    isValid = () => {
        return this.state.validations.filter((vl) => vl.isValid === false).length <= 0;
    }

    // ---- Generic Validation
    fieldIsValid = (field) => {
        return this.state.validations.filter((vl) => vl.isValid === false && vl.field === field).length <= 0;
    }

    groupIsValid = (group) => {
        return this.state.validations.filter((vl) => vl.isValid === false && vl.group === group).length <= 0;
    }

    fieldGroupIsValid = (field, group) => {
        return this.state.validations.filter((vl) => vl.isValid === false && vl.field === field && vl.group === group).length <= 0;
    }

    convertToUppercase(e) {
        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;
        e.target.value = e.target.value.toUpperCase();
        e.target.setSelectionRange(start, end);
    }
}
